/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cIf from 'classnames';

// Uses window.tsapp

var _ = require('lodash');
var accounting = require('accounting');
var guidEmpty = '00000000-0000-0000-0000-000000000000';

import {up} from 'ts-util';
import {NumberSpinner} from '../../../../jsxctl/utilctl';
import { MembershipCardConditionPopup } from '../memberships';


export interface PriceRowProps {
    priceitem: any,
    priceRequest: any,
    isTicketQtyReadonly?: boolean,
    showOnlyWholePricesOnInternet?: boolean,
    numberoftickets: number,
    creditCardMessageState?: any,
    hasCreditCardMessageSeen: (creditCardConditionID: string) => void,
    onChange: (priceID: string, priceRequest: any) => void,
    resetPriceGroupQtyAfterClickToPriceName: (priceGroupName: string) => void,
    onMoreInformationsClick: (membershipTypeID: string) => void,
    taxesOnlyAtCheckout: boolean
}

export interface PriceRowState {
    showPopupMessageCreditCard: boolean
}

export class PriceRow extends Component<PriceRowProps, PriceRowState> {
    containerRef: React.RefObject<HTMLDivElement>;
    static displayName: string;
    static defaultProps: Partial<PriceRowProps> = { priceRequest: { qty: null } };

    constructor(props) {
        super(props);

        this.state = {
            showPopupMessageCreditCard: false
        };

        this.containerRef = React.createRef();

        this.handleChangeQty = this.handleChangeQty.bind(this);
        this.handlePopupClose = this.handlePopupClose.bind(this);
        this.handleResetPriceGroupQtyAfterClickToPriceName = this.handleResetPriceGroupQtyAfterClickToPriceName.bind(this);
    }

    handleChangeQty(quantity) {
        var isnumorempty = /(^\s*)|(\d*$)/.test(quantity);

        if(isnumorempty)
        {
            this.checkRequiredCreditCardDisplayMessaage(quantity);

            this.props.onChange(this.props.priceitem.PriceID, up(this.props.priceRequest, { qty: { $set: quantity } }));
        }
    }

    handleCreditCardMessageSeen(creditCardConditionID) {
        this.props.hasCreditCardMessageSeen(creditCardConditionID);
    }

    checkRequiredCreditCardDisplayMessaage(qty) {
        if(this.props.priceitem.RequiredCreditCardConditionID !== guidEmpty) {
            try{
                var newVal = parseInt(qty);

                if(newVal > 0 && this.props.creditCardMessageState[this.props.priceitem.RequiredCreditCardConditionID] !== true){
                    this.setState({ showPopupMessageCreditCard: true });
                }
            }
            catch(e) {}
        }
    }

    handlePopupClose() {
        this.setState({ showPopupMessageCreditCard: false });
        this.handleCreditCardMessageSeen(this.props.priceitem.RequiredCreditCardConditionID);
    }

    handleOnMoreInformationsClick(membershipTypeID) {
        this.props.onMoreInformationsClick(membershipTypeID);
    }

    handleResetPriceGroupQtyAfterClickToPriceName() {
        this.checkRequiredCreditCardDisplayMessaage(this.props.numberoftickets);
        if(this.props.resetPriceGroupQtyAfterClickToPriceName != null) this.props.resetPriceGroupQtyAfterClickToPriceName(this.props.priceitem.Name);
    }

    calculTotal() {
        var isnum = /^\d*$/.test(this.props.priceRequest.qty);

        if(isnum)
            return accounting.formatMoney((this.props.taxesOnlyAtCheckout ? this.props.priceitem.TotalBeforeTaxes : this.props.priceitem.Total) * this.props.priceRequest.qty);
        else
            return accounting.formatMoney(0);
    }

    render () {
        var priceLine = this.props.priceitem.Name;
        if (this.props.priceitem.RequiresMembership)
            priceLine =  priceLine + " *";


        priceLine = <p className="priceline" title={priceLine}>{priceLine} {(!this.props.showOnlyWholePricesOnInternet ? <span className="badge nowrap visible-xs-inline-block">{accounting.formatMoney(this.props.priceitem.Total)}</span> : "")}</p>;

        if(!this.props.priceitem.Disabled
           && !this.props.priceitem.IsUnavailable
           && !this.props.priceitem.IsSoldOut)
            priceLine = (
                <h5 className="btn-link" style={{cursor:'pointer'}} onClick={this.handleResetPriceGroupQtyAfterClickToPriceName}>
                    {priceLine}
                </h5>);
        else
            priceLine = (
                <h5>{priceLine}</h5>
            );

        var ctrlQty = null;

        //alert(this.props.priceitem.RequiredMembershipTypeID);

        if(this.props.priceitem.IsSoldOut) {
            ctrlQty = (
                <h5 className="text-center">
                    {tsapp.tr("Limite atteinte!")}
                </h5>
            );
        } else if(this.props.priceitem.IsUnavailable) {
            ctrlQty = (
                <h5 className="text-center">
                    {tsapp.tr("Non disponible")}
                </h5>
            );
        } else if(this.props.isTicketQtyReadonly) {
            ctrlQty = <h5 className="text-center">
                {_.isInteger(this.props.priceRequest.qty) && this.props.priceRequest.qty !== 0 ? this.props.priceRequest.qty : ""}
            </h5>;
        } else if(this.props.priceitem.Disabled && this.props.priceitem.RequiredMembershipTypeID != guidEmpty) {
            ctrlQty = <button className="moreInfos btn btn-default col-xs-12" onClick={function() { this.handleOnMoreInformationsClick(this.props.priceitem.RequiredMembershipTypeID); }.bind(this) }>
                <span className="hidden-xs">{tsapp.tr("Entrez votre # d’abonné ici")}</span>
                <span className="visible-xs">{tsapp.tr("# d’abonné ici")}</span>
            </button>;
        } else {
            var popupMsg = null;


            
            if(this.state.showPopupMessageCreditCard) {
                popupMsg = <MembershipCardConditionPopup
                    container={this.containerRef.current}
                    creditCardCondition={
                        {
                            id: this.props.priceitem.RequiredCreditCardConditionID,
                            name: {
                                fr: this.props.priceitem.CreditCardConditionName,
                                en: this.props.priceitem.CreditCardConditionName
                            },
                            explanationText: {
                                fr: this.props.priceitem.CreditCardConditionInfoText,
                                en: this.props.priceitem.CreditCardConditionInfoText
                            }
                    }}
                    onConfirmPaidWithCreditCardCondition={this.handlePopupClose}
                    onPopupClose={this.handlePopupClose}
                />;
            }

            ctrlQty = (
                <div>
                    <NumberSpinner value={this.props.priceRequest.qty || undefined}
                                   hideZero={true}
                                   min={0} max={this.props.numberoftickets}
                                   disabled={this.props.priceitem.Disabled}
                                   onChange={this.handleChangeQty} />
                </div>
            );
        }

        
        return (
            <div className="list-group-item bg-default">
                <div className="priceRow row">
                    <div id="lblPriceGroupName" className="col-xs-12 col-sm-4 nowrap">
                        {priceLine}
                    </div>
                    {(!this.props.showOnlyWholePricesOnInternet ?
                      <div id="lblPrice" className="text-right hidden-xs text-primary text-bold col-sm-2">
                          <h5 className="nowrap">{accounting.formatMoney(this.props.taxesOnlyAtCheckout ? this.props.priceitem.TotalBeforeTaxes : this.props.priceitem.Total)}</h5>
                      </div>
                     : null)}
                     <div className={cIf("pull-top ", { "col-sm-offset-4": this.props.showOnlyWholePricesOnInternet, "col-xs-8 col-sm-4":true })}>
                         <div ref={this.containerRef} />
                         {ctrlQty}{popupMsg}
                     </div>
                     {(!this.props.showOnlyWholePricesOnInternet ?
                      <div className="text-right text-primary text-bold nowrap col-xs-4 col-sm-2">
                          <h5>{this.calculTotal()}</h5>
                      </div>
                     : null)}
                </div>
            </div>);
    }
};
PriceRow.displayName = "PriceRow";
